import * as z from "zod";

export const disconnectRefundidIntegration = {
  name: "disconnectRefundidIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
